import React from "react";

const BoxIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 114.9 62",
  style: {
    enableBackground: "new 0 0 114.9 62"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  .st0{fill:#0061D5;}\n "), /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
  xmlns: "ns_sfw;"
}, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
  bottomLeftOrigin: "true",
  height: 62,
  width: 114.9,
  x: 142.6,
  y: -231
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M113.8,55.1c1.4,2,1.1,4.6-0.6,6c-2,1.4-4.9,1.1-6.3-0.6l-10-12.9l-9.8,12.6c-1.4,2-4.3,2-6.3,0.6 c-2-1.4-2.3-4-0.9-6l11.5-14.9L80,24.9c-1.4-2-0.9-4.9,0.9-6.3c2-1.4,4.9-0.9,6.3,0.9l9.8,12.9l10-12.3c1.4-2,4-2.3,6.3-0.9 c2,1.4,2,4.3,0.6,6.3l-11.2,14.6L113.8,55.1z M61.7,53.3c-7.5,0-13.5-5.7-13.5-13.2c0-7.2,6-13.2,13.5-13.2s13.5,6,13.5,13.2 C74.8,47.6,68.8,53.3,61.7,53.3z M22.1,53.3c-7.5,0-13.5-5.7-13.5-13.2c0-7.2,6-13.2,13.5-13.2s13.5,6,13.5,13.2 C35.6,47.6,29.5,53.3,22.1,53.3z M61.7,18.4c-8.3,0-15.8,4.6-19.5,11.5C38.4,22.9,31,18.4,22.4,18.4c-5.2,0-9.8,1.7-13.5,4.3V4.3 C8.9,2,6.9,0,4.6,0C2,0,0,2,0,4.3v36.1c0.3,12,10,21.5,22.1,21.5c8.6,0,16.1-4.9,19.8-11.8c3.7,6.9,11.2,11.8,19.5,11.8 c12.3,0,22.4-9.8,22.4-22.1C84,28.1,74,18.4,61.7,18.4z"
})));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BoxIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;